//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import List from '@/components/table';
import messageBox from '@/components/messageBox';
import ImportJson from './component/ImportJson.vue';
import AddModel from './component/addModel';
import { mapGetters, mapActions } from 'vuex';
import { openDownloadDialog } from '@/utils/util';
import _ from 'lodash';

export default {
  components: {
    List,
    ImportJson,
    AddModel,
    messageBox,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      // tab状态
      activeStatus: '1',
      tabList: [
        { name: '1', label: '已启用' },
        { name: '2', label: '已停用' },
      ],
      // 搜索表单
      flowForm: {
        name: '',
        app_id: '',
      },
      layout: [
        { name: 'edit_process_name', label: '名称' },
        { name: 'process_key', label: '流程key' },
        { name: 'module', label: '业务模版' },
        { name: 'version', label: '版本' },
        { name: 'preset', label: '系统预置' },
        { name: 'remark', label: '备注', limit: 8 },
        { name: 'create_time', label: '创建时间' },
        { name: 'update_time', label: '更新时间' },
      ],
      // 新建窗口展示
      basicInfoVisable: false,
      // 模型文件部署
      deployVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      appList: 'workflow/getAppList',
      moudleList: 'workflow/getBusinessModuleList',
    }),
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = [
        'workflowModel_workflow_create',
        'workflowModel_workflow_modelImport',
        'workflowModel_workflow_itemRelease',
        'workflowModel_workflow_itemDelete',
        'workflowModel_workflow_itemStop',
        'workflowModel_workflow_itemEnable',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
  },
  watch: {
    activeStatus() {
      this.flowForm.name = '';
      this.flowForm.app_id = '';
      if (this.loading) this.refresh();
    },
  },
  created() {
    this.getAppList();
    this.requestBusinessOptionList();
    const tab = this.$route?.query?.tab;
    if (tab) {
      this.activeStatus = tab;
    }
    this.loading = true;
  },
  methods: {
    ...mapActions({
      getAppList: 'workflow/requestAppList',
      requestBusinessOptionList: 'workflow/requestBusinessOptionList',
    }),
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },
    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      return this.$request({
        url: this.$api.getEditProcessList,
        data: {
          page_index: pageIndex,
          page_size: pageSize,
          status: Number(this.activeStatus),
          name: this.flowForm.name,
          app_id: this.flowForm.app_id,
        },
      }).then(({ edit_process_list, total = 0 }) => {
        const computedList = edit_process_list.map((item) => ({
          ...item,
          module:
            this.moudleList.find((moudle) => {
              return moudle.value === item.module;
            })?.label || '',
          preset: item.preset ? '是' : '否',
        }));
        return {
          list: computedList,
          total: Number(total),
        };
      });
    },
    // 表单查询
    handleInput: _.debounce(function () {
      this.refresh();
    }, 1000),
    handleReset() {
      this.flowForm.name = '';
      this.flowForm.app_id = '';
      this.refresh();
    },
    // 增删改
    add() {
      this.basicInfoVisable = true;
    },
    edit({ id }) {
      this.$router.push({
        name: 'workflow-detail',
        query: {
          id,
          tab: this.activeStatus,
        },
      });
    },
    del({ id }) {
      this.$refs.messageBox.show({
        title: '提示',
        content: '确定删除该数据吗?',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteEditProcess,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },
    submit({ id }) {
      this.$refs.messageBox.show({
        title: '确认部署发布？',
        content: '部署发布成功后流转到流程管理页',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.submitEditProcess,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.$message({
                message: '发布成功',
                type: 'success',
              });
            },
          });
        },
      });
    },
    // 导出JSON
    exportJSON({ id, version }) {
      this.$request({
        url: this.$api.getEditProcessById,
        data: { id },
        cb: ({ process }) => {
          const data = {
            edit_process_name: process.edit_process_name,
            edit_json: process.edit_process_json,
            edit_process_desc: process.edit_process_desc || '',
            module: process.module,
            process_key: process.process_key,
            preset: process.preset,
            remark: process.remark || '',
            app_id: process.app_id,
            actions: process.actions || [],
            biz_type: process.biz_type,
          };
          const filename = `${process.edit_process_name || '导出'}${
            process.edit_process_name && version ? `(${version})` : ''
          }`;
          openDownloadDialog(
            new Blob([JSON.stringify(data)], { type: 'application/json' }),
            `${filename}.json`,
          );
        },
      });
    },
    // 启用/禁用
    changeStatus({ id }, status) {
      // 接口名
      let api;
      // 标题
      let title;
      // 图标类型
      let type;
      switch (status) {
        case '1':
          api = this.$api.enableEditProcess;
          title = '确定启用该模型吗?';
          type = 'warning';
          break;
        case '2':
          api = this.$api.disableEditProcess;
          title = '确定停用该模型吗?';
          type = 'danger';
          break;
      }
      if (!api) return;
      this.$refs.messageBox.show({
        title,
        noBody: true,
        titleIconType: type,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: api,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },
  },
};
